import { isEqual } from 'lodash';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';

import { ACTION_BLUE, FEED_BACK } from '../../theme/colorConstants';
import { BULK_ACTION_TYPES } from '../../views/timekeeping/timekeepingConstants';
import { getCardFilterPayload } from '../../views/timekeeping/timekeepingHelpers';

const getStepData = ({
  timecardCounts,
  role,
  startDate,
  endDate,
  handleOnCardClick,
  currentParams,
  workedTimeEpochs,
}) => [
  {
    // FIXME: HandleOnCardClick is doing way more htan it probably needs to.
    // Does it just need to call a CB to force the modal to open? Then that modal would go and get all the data it needs for its use case.
    color: FEED_BACK.GREEN_70,
    onCardClick: () => {
      handleOnCardClick({
        filterVal: getCardFilterPayload(startDate, endDate).step1,
        actionType:
          role === UserRole.EMPLOYER ? BULK_ACTION_TYPES.APPROVE : BULK_ACTION_TYPES.RESOLVE,
        customCount: timecardCounts?.readyToApproveOrResolve,
        totalTimeEpoch:
          role === UserRole.EMPLOYER
            ? workedTimeEpochs?.corporation?.readyToApproveOrResolveEpoch
            : workedTimeEpochs?.readyToApproveOrResolveEpoch,
      });
    },
    header: 'timekeeping.counterCards.step1',
    subHeader:
      role === UserRole.EMPLOYER
        ? 'timekeeping.counterCards.step1.subHeaderApprove'
        : 'timekeeping.counterCards.step1.subHeaderResolve',
    body: 'timekeeping.counterCards.step1.body',
    buttonText:
      role === UserRole.EMPLOYER
        ? 'timekeeping.counterCards.selectButtonTextApprove'
        : 'timekeeping.counterCards.selectButtonTextResolve',
    hideButton: role === UserRole.RECRUITER,
    count: timecardCounts?.readyToApproveOrResolve,
    isCompleted: timecardCounts?.readyToApproveOrResolve === 0,
    isSelected: isEqual(currentParams, getCardFilterPayload(startDate, endDate).step1),
  },
  {
    color: ACTION_BLUE.INDIGO_BLUE_REST,
    onCardClick: () =>
      handleOnCardClick({ filterVal: getCardFilterPayload(startDate, endDate).step2 }),
    header: 'timekeeping.counterCards.step2',
    subHeader: 'timekeeping.counterCards.step2.subHeader',
    body: 'timekeeping.counterCards.step2.body',
    buttonText: 'timekeeping.counterCards.viewButtonText',
    count: timecardCounts?.suspiciousOrMissingPunches,
    isCompleted: timecardCounts?.suspiciousOrMissingPunches === 0,
    isSelected: isEqual(currentParams, getCardFilterPayload(startDate, endDate).step2),
  },
  {
    color: FEED_BACK.ORANGE_20,
    onCardClick: () =>
      handleOnCardClick({ filterVal: getCardFilterPayload(startDate, endDate).step3 }),
    header: 'timekeeping.counterCards.step3',
    subHeader: 'timekeeping.counterCards.step3.subHeader',
    body: 'timekeeping.counterCards.step3.body',
    buttonText: 'timekeeping.counterCards.viewButtonText',
    count: timecardCounts?.disputed,
    isCompleted: timecardCounts?.disputed === 0,
    isSelected: isEqual(currentParams, getCardFilterPayload(startDate, endDate).step3),
  },
  ...(role === UserRole.RECRUITER || role === UserRole.ADMIN
    ? [
        {
          color: FEED_BACK.ORANGE_20,
          onCardClick: () =>
            handleOnCardClick({
              filterVal: getCardFilterPayload(startDate, endDate).step4,
            }),
          header: 'timekeeping.counterCards.step4',
          subHeader: 'timekeeping.counterCards.step4.subHeader',
          body: 'timekeeping.counterCards.step4.body',
          buttonText: 'timekeeping.counterCards.viewButtonText',
          count: timecardCounts?.readyToFinalize,
          isCompleted: timecardCounts?.readyToFinalize === 0,
          isSelected: isEqual(currentParams, getCardFilterPayload(startDate, endDate).step4),
        },
      ]
    : []),
];

export default getStepData;
